module.exports = __webpack_public_path__ + "img/saved.22448a99.svg";